import * as React from 'react';
import Modal from '@mui/material/Modal';
import Link from '@mui/material/Link';
import Container from '@mui/material/Container';
import { CloseOutlined } from '@mui/icons-material';
import Typography from '@mui/material/Typography';
import useTheme from '@mui/material/styles/useTheme';
import { IconButton, List, ListItem, Paper } from '@mui/material';

export default function HelpModal({showModal, onClose}) {
    const theme = useTheme();
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '90%',
        maxWidth: 600, 
        minHeight: 200,
        bgcolor: theme.palette.background.paper,
        borderRadius: 5,
        p: 4,
    };

  return (
    <Modal open={showModal} onClose={onClose}>
    <Paper style={style}>
        <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="close"
                sx={{ position: 'absolute', top: "5px", right: "5px"}}
                onClick={onClose}
            >
            <CloseOutlined />
        </IconButton>
        <Container sx={{margin: 1}}>  
            <Typography variant='h4'>How to play:</Typography>
            <Typography variant='h6'>Use the numbers to count as high as you can</Typography>
            <List sx={{ listStyleType: 'disc', pl: 4 }}>
                <ListItem sx={{ display: 'list-item' }}>
                    <Typography variant='p'>When you reach your current target, the target will go up by 1</Typography>
                </ListItem>
                <ListItem sx={{ display: 'list-item' }}>
                    <Typography variant='p'>Numbers can only be used to reach any target</Typography>
                </ListItem>
                <ListItem sx={{ display: 'list-item' }}>
                    <Typography variant='p'>Hard mode: you have to use all of the numbers to reach each target</Typography>
                </ListItem>
                <ListItem sx={{ display: 'list-item' }}>
                    <Typography variant='p'>At midnight eastern time, a new set of numbers is generated</Typography>
                </ListItem>
                <ListItem sx={{ display: 'list-item' }}>
                    <Typography variant='p'>See if you can reach the highest number out of everyone each day!</Typography>
                </ListItem>
            </List>
            <Typography variant='subtitle'>To learn more about this project check out <Link underline='none' target='_blank' href="https://www.evantlee.com/">my website</Link> and <Link underline='none' target='_blank' href="https://evantlee.substack.com/p/jmi-mathlee-a-childhood-math-game">this blog post!</Link></Typography>
            <br/>
            <br/>
            <i><Typography variant='subtitle'>If you like this, <Link underline='none' target='_blank' href="https://www.buymeacoffee.com/evantlee3">buy me a coffee here!</Link></Typography></i>
        </Container>
    </Paper>
    </Modal>
  );
}